export interface Plan {
	id: string;
	name: string;
	sessionsPerMonth: number;
	description: string;
	price: number;
	pricePerSession: number;
	features: string[];
	recommended?: boolean;
}

/**
 * Espelha os clubes B2C (varejo) cadastrados no admin:
 * Plumaa Básico, Plumaa Padrão e Plumaa Premium.
 * Mantenha nome, descrição, preço e benefícios iguais ao admin.
 */
export const plansList: Plan[] = [
	{
		id: 'basico',
		name: 'Básico',
		sessionsPerMonth: 1,
		description:
			'O ponto de partida ideal para manter seu bem-estar emocional em dia, contando com 1 sessão mensal de acompanhamento psicológico.',
		price: 67.97,
		pricePerSession: 67.97,
		features: [
			'1 Sessão de psicólogo GRÁTIS / mês',
			'Acesso a terapia por apenas R$ 67,90 (valor por sessão adicional)',
			'Acesso a nutricionista por apenas R$ 59,50 a sessão.',
		],
	},
	{
		id: 'padrao',
		name: 'Padrão',
		sessionsPerMonth: 2,
		description:
			'O equilíbrio perfeito para o seu desenvolvimento contínuo, oferecendo 2 sessões mensais para um cuidado mais próximo.',
		price: 133.97,
		pricePerSession: 66.99,
		features: [
			'2 sessões de psicólogo GRÁTIS / mês',
			'Acesso a terapia por apenas R$ 67,90 (valor por sessão adicional)',
			'Acesso a nutricionista por apenas R$ 33,60 a sessão.',
		],
		recommended: true,
	},
	{
		id: 'premium',
		name: 'Premium',
		sessionsPerMonth: 4,
		description:
			'A experiência completa de suporte emocional, garantindo 4 sessões mensais para uma evolução rápida e aprofundada.',
		price: 267.97,
		pricePerSession: 66.99,
		features: [
			'4 sessões de psicólogo GRÁTIS / mês',
			'1 Sessão de Nutricionista GRÁTIS / mês',
			'Acesso a sessão médica com especialistas em saúde mental por apenas R$ 89,33 a sessão.',
		],
	},
];

export const basePrices: Record<number, number> = {
	1: 67.97,
	2: 133.97,
	4: 267.97,
};

/** Menor mensalidade entre os planos — usado no "A partir de" do hero e do CTA. */
export const cheapestPlanPrice = Math.min(...plansList.map((p) => p.price));

export const formatPrice = (value: number) =>
	value.toFixed(2).replace('.', ',');
